<div class="ficha-cadastro-detalhe-cliente-caminhao-proprio">
  <div
    class="row form-group pb0 ficha-cadastro-detalhe-cliente-caminhao-proprio_title">
    <span>Informações dos Caminhões Próprios do Cliente</span>
  </div>
  <div
    class="blue-box row"
    *ngFor="let veiculoProprio of veiculosProprio; let i = index">
    <span class="ficha-cadastro-detalhe-cliente-caminhao-proprio_subtitle">
      Caminhão {{i + 1}}
    </span>
    <app-dados-caminhao-proprio-tempo
      (changeFormValid)="changeFormValid('info', i, $event)"
      (changeForm)="changeForm('info', i, $event)"
      [value]="veiculoProprio.info">
    </app-dados-caminhao-proprio-tempo>
    <app-dados-caminhao-proprio-quitado
      (changeFormValid)="changeFormValid('quitado', i, $event)"
      (changeForm)="changeForm('quitado', i, $event)"
      [value]="veiculoProprio.quitado">
    </app-dados-caminhao-proprio-quitado>
    <app-dados-caminhao-proprio-implemento
      (changeFormValid)="changeFormValid('implemento', i, $event)"
      (changeForm)="changeForm('implemento', i, $event)"
      [value]="veiculoProprio.implemento">
    </app-dados-caminhao-proprio-implemento>
  </div>

  <div class="row">
    <div class="marginT30 form-group tab-buttons">

      <a
        (click)="onClickPrevious()"
        class="bt-back btn btn-border-orange pull-left">
        <i class="fa fa-arrow-left mrBt"></i> Voltar</a>

      <a
        class="bt-go btn btn-full-orange pull-right"
        [ngClass]="{'disabled': !isNextAvailable}"
        (click)="onClickNext()">Continuar
        <i class="fa fa-arrow-right mlBt"></i>
      </a>

    </div>
  </div>
</div>
